// extracted by mini-css-extract-plugin
module.exports = {"columnsContainer":"Stats_columnsContainer__1xzUr","repos":"Stats_repos__30qWL","followers":"Stats_followers__16cAN","following":"Stats_following__1R9f6"};